import commonDropDownStyle from "../templates/CommonDropDown.style";
import commonDropDownHzeroStyle from "../templates-hzero/CommonDropDown.style";
var commonDropdownData = {
  name: 'commonDropdown',
  data: [],
  onlyTemplate: [commonDropDownStyle, commonDropDownHzeroStyle]
};
export default commonDropdownData;